import { keyToNote } from '../constants.js';

import c0 from './MusicNotes/c0.wav';
import c0s from './MusicNotes/c0s.wav';
import d0 from './MusicNotes/d0.wav';
import d0s from './MusicNotes/d0s.wav';
import e0 from './MusicNotes/e0.wav';
import f0 from './MusicNotes/f0.wav';
import f0s from './MusicNotes/f0s.wav';
import g0 from './MusicNotes/g0.wav';
import g0s from './MusicNotes/g0s.wav';
import a0 from './MusicNotes/a0.wav';
import a0s from './MusicNotes/a0s.wav';
import b0 from './MusicNotes/b0.wav';
import c1 from './MusicNotes/c1.wav';
import c1s from './MusicNotes/c1s.wav';
import d1 from './MusicNotes/d1.wav';
import d1s from './MusicNotes/d1s.wav';
import e1 from './MusicNotes/e1.wav';
import f1 from './MusicNotes/f1.wav';
import f1s from './MusicNotes/f1s.wav';
import g1 from './MusicNotes/g1.wav';
import g1s from './MusicNotes/g1s.wav';
import a1 from './MusicNotes/a1.wav';
import a1s from './MusicNotes/a1s.wav';
import b1 from './MusicNotes/b1.wav';
import c2 from './MusicNotes/c2.wav';
import c2s from './MusicNotes/c2s.wav';
import d2 from './MusicNotes/d2.wav';
import d2s from './MusicNotes/d2s.wav';
import e2 from './MusicNotes/e2.wav';
import f2 from './MusicNotes/f2.wav';
import f2s from './MusicNotes/f2s.wav';
import g2 from './MusicNotes/g2.wav';
import g2s from './MusicNotes/g2s.wav';
import a2 from './MusicNotes/a2.wav';
import a2s from './MusicNotes/a2s.wav';
import b2 from './MusicNotes/b2.wav';
import c3 from './MusicNotes/c3.wav';

const C0 = new Audio(c0);
const C0s = new Audio(c0s);
const D0 = new Audio(d0);
const D0s = new Audio(d0s);
const E0 = new Audio(e0);
const F0 = new Audio(f0);
const F0s = new Audio(f0s);
const G0 = new Audio(g0);
const G0s = new Audio(g0s);
const A0 = new Audio(a0);
const A0s = new Audio(a0s);
const B0 = new Audio(b0);
const C1 = new Audio(c1);
const C1s = new Audio(c1s);
const D1 = new Audio(d1);
const D1s = new Audio(d1s);
const E1 = new Audio(e1);
const F1 = new Audio(f1);
const F1s = new Audio(f1s);
const G1 = new Audio(g1);
const G1s = new Audio(g1s);
const A1 = new Audio(a1);
const A1s = new Audio(a1s);
const B1 = new Audio(b1);
const C2 = new Audio(c2);
const C2s = new Audio(c2s);
const D2 = new Audio(d2);
const D2s = new Audio(d2s);
const E2 = new Audio(e2);
const F2 = new Audio(f2);
const F2s = new Audio(f2s);
const G2 = new Audio(g2);
const G2s = new Audio(g2s);
const A2 = new Audio(a2);
const A2s = new Audio(a2s);
const B2 = new Audio(b2);
const C3 = new Audio(c3);

const noteList = [
  C0, C0s, D0, D0s, E0, F0, F0s, G0, G0s, A0, A0s, B0, C1, C1s, D1, D1s, E1, F1, F1s, G1, G1s, A1, A1s, B1, C2, C2s, D2, D2s, E2, F2, F2s, G2, G2s, A2, A2s, B2, C3 
];

function Play() {
  window.addEventListener('keydown', (e) => {
    if ('c0' === keyToNote[e.key]) {
      noteList[0].play();
    }
    if ('c0s' === keyToNote[e.key]) {
        noteList[1].play();
    }
    if ('d0' === keyToNote[e.key]) {
        noteList[2].play();
    }
    if ('d0s' === keyToNote[e.key]) {
        noteList[3].play();
    }
    if ('e0' === keyToNote[e.key]) {
        noteList[4].play();
    }
    if ('f0' === keyToNote[e.key]) {
        noteList[5].play();
    }
    if ('f0s' === keyToNote[e.key]) {
        noteList[6].play();
    }
    if ('g0' === keyToNote[e.key]) {
        noteList[7].play();
    }
    if ('g0s' === keyToNote[e.key]) {
        noteList[8].play();
    }
    if ('a0' === keyToNote[e.key]) {
        noteList[9].play();
    }
    if ('a0s' === keyToNote[e.key]) {
        noteList[10].play();
    }
    if ('b0' === keyToNote[e.key]) {
        noteList[11].play();
    }
    if ('c1' === keyToNote[e.key]) {
        noteList[12].play();
    }
    if ('c1s' === keyToNote[e.key]) {
        noteList[13].play();
    }
    if ('d1' === keyToNote[e.key]) {
        noteList[14].play();
    }
    if ('d1s' === keyToNote[e.key]) {
        noteList[15].play();
    }
    if ('e1' === keyToNote[e.key]) {
        noteList[16].play();
    }
    if ('f1' === keyToNote[e.key]) {
        noteList[17].play();
    }
    if ('f1s' === keyToNote[e.key]) {
        noteList[18].play();
    }
    if ('g1' === keyToNote[e.key]) {
        noteList[19].play();
    }
    if ('g1s' === keyToNote[e.key]) {
        noteList[20].play();
    }
    if ('a1' === keyToNote[e.key]) {
        noteList[21].play();
    }
    if ('a1s' === keyToNote[e.key]) {
        noteList[22].play();
    }
    if ('b1' === keyToNote[e.key]) {
        noteList[23].play();
    }
    if ('c2' === keyToNote[e.key]) {
        noteList[24].play();
    }
    if ('c2s' === keyToNote[e.key]) {
        noteList[25].play();
    }
    if ('d2' === keyToNote[e.key]) {
        noteList[26].play();
    }
    if ('d2s' === keyToNote[e.key]) {
        noteList[27].play();
    }
    if ('e2' === keyToNote[e.key]) {
        noteList[28].play();
    }
    if ('f2' === keyToNote[e.key]) {
        noteList[29].play();
    }
    if ('f2s' === keyToNote[e.key]) {
        noteList[30].play();
    }
    if ('g2' === keyToNote[e.key]) {
        noteList[31].play();
    }
    if ('g2s' === keyToNote[e.key]) {
        noteList[32].play();
    }
    if ('a2' === keyToNote[e.key]) {
        noteList[33].play();
    }
    if ('a2s' === keyToNote[e.key]) {
        noteList[34].play();
    }
    if ('b2' === keyToNote[e.key]) {
        noteList[35].play();
    }
    if ('c3' === keyToNote[e.key]) {
        noteList[36].play();
    }
  });
  window.addEventListener('keyup', (e) => {
    if ('c0' === keyToNote[e.key]) {
        noteList[0].pause();
      }
      if ('c0s' === keyToNote[e.key]) {
          noteList[1].pause();
      }
      if ('d0' === keyToNote[e.key]) {
          noteList[2].pause();
      }
      if ('d0s' === keyToNote[e.key]) {
          noteList[3].pause();
      }
      if ('e0' === keyToNote[e.key]) {
          noteList[4].pause();
      }
      if ('f0' === keyToNote[e.key]) {
          noteList[5].pause();
      }
      if ('f0s' === keyToNote[e.key]) {
          noteList[6].pause();
      }
      if ('g0' === keyToNote[e.key]) {
          noteList[7].pause();
      }
      if ('g0s' === keyToNote[e.key]) {
          noteList[8].pause();
      }
      if ('a0' === keyToNote[e.key]) {
          noteList[9].pause();
      }
      if ('a0s' === keyToNote[e.key]) {
          noteList[10].pause();
      }
      if ('b0' === keyToNote[e.key]) {
          noteList[11].pause();
      }
      if ('c1' === keyToNote[e.key]) {
          noteList[12].pause();
      }
      if ('c1s' === keyToNote[e.key]) {
          noteList[13].pause();
      }
      if ('d1' === keyToNote[e.key]) {
          noteList[14].pause();
      }
      if ('d1s' === keyToNote[e.key]) {
          noteList[15].pause();
      }
      if ('e1' === keyToNote[e.key]) {
          noteList[16].pause();
      }
      if ('f1' === keyToNote[e.key]) {
          noteList[17].pause();
      }
      if ('f1s' === keyToNote[e.key]) {
          noteList[18].pause();
      }
      if ('g1' === keyToNote[e.key]) {
          noteList[19].pause();
      }
      if ('g1s' === keyToNote[e.key]) {
          noteList[20].pause();
      }
      if ('a1' === keyToNote[e.key]) {
          noteList[21].pause();
      }
      if ('a1s' === keyToNote[e.key]) {
          noteList[22].pause();
      }
      if ('b1' === keyToNote[e.key]) {
          noteList[23].pause();
      }
      if ('c2' === keyToNote[e.key]) {
          noteList[24].pause();
      }
      if ('c2s' === keyToNote[e.key]) {
          noteList[25].pause();
      }
      if ('d2' === keyToNote[e.key]) {
          noteList[26].pause();
      }
      if ('d2s' === keyToNote[e.key]) {
          noteList[27].pause();
      }
      if ('e2' === keyToNote[e.key]) {
          noteList[28].pause();
      }
      if ('f2' === keyToNote[e.key]) {
          noteList[29].pause();
      }
      if ('f2s' === keyToNote[e.key]) {
          noteList[30].pause();
      }
      if ('g2' === keyToNote[e.key]) {
          noteList[31].pause();
      }
      if ('g2s' === keyToNote[e.key]) {
          noteList[32].pause();
      }
      if ('a2' === keyToNote[e.key]) {
          noteList[33].pause();
      }
      if ('a2s' === keyToNote[e.key]) {
          noteList[34].pause();
      }
      if ('b2' === keyToNote[e.key]) {
          noteList[35].pause();
      }
      if ('c3' === keyToNote[e.key]) {
          noteList[36].pause();
      }
  })
}

export default Play